// import React, { useState, Component } from "react";
// export default class AddUser extends Component {
//   constructor(props) {
//     super(props);
//     this.state = {};
//   }

//   render() {
//     return <div>add user</div>;
//   }
// }
import React, { Component } from "react";
import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Grid,
  Divider,
  Switch,
  TextField,
  Typography,
  colors
} from "@material-ui/core";
import Chip from "@material-ui/core/Chip";
import Paper from "@material-ui/core/Paper";
import ChipInput from "material-ui-chip-input";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { Multiselect } from "multiselect-react-dropdown";
import axios from "axios";
import { toast } from "react-toastify";
import useAutocomplete from "@material-ui/lab/useAutocomplete";
import NoSsr from "@material-ui/core/NoSsr";
import CheckIcon from "@material-ui/icons/Check";
import CloseIcon from "@material-ui/icons/Close";
import GetAppIcon from '@material-ui/icons/GetApp';
import CalendarTodayIcon from '@material-ui/icons/CalendarTodayOutlined';
import styled from "styled-components";
import loader from "../images/loader.gif"
import _apiData from "../metaData";
import "./ward.css";

import DatePicker from "react-datepicker";
import { TablePagination } from 'react-pagination-table';
import downloadCsv from 'download-csv';

import "react-datepicker/dist/react-datepicker.css";

const TableHeader = ["ward","Bus_Stand","Commercial","Community_Hall","Educational","GOI_Office","Industrial","Institutional","Mixed","Others","Railway_Station","Religious-Hindu_Temple","Religious-Majid","Religious-Church","Religious-Other","Residential","Slum","State_Govt_Office","Storage_Building","Under_Construction","Unsafe","Total","Download","DownloadRow"];

let apiData = _apiData[0];

let workOrder = localStorage.getItem("workOrderObj");
if (workOrder) {
  workOrder = JSON.parse(workOrder);
}
let work_order;
if (workOrder) {
  work_order = workOrder.workOrder;
}

let top100Films = [
  { title: "" },
  { title: "venu" },
  { title: "gopal" },
  { title: "venu1" },
  { title: "gopal1" },
  { title: "venu2" },
  { title: "gopal2" },
  { title: "venu3" },
  { title: "gopal3" }
];
let self;
let selectedProjectsNew = [];
let selectedAppsNew = [];

let loginDetails = localStorage.getItem("loginDetails");
if (loginDetails) {
  loginDetails = JSON.parse(loginDetails);
}

const Label = styled("label")`
  padding: 0 0 4px;
  line-height: 1.5;
  display: block;
`;

const InputWrapper = styled("div")`
  width: 300px;
  border: 1px solid #d9d9d9;
  background-color: #fff;
  border-radius: 4px;
  padding: 1px;
  display: flex;
  flex-wrap: wrap;

  &:hover {
    border-color: #40a9ff;
  }

  &.focused {
    border-color: #40a9ff;
    box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
  }

  & input {
    font-size: 14px;
    height: 30px;
    box-sizing: border-box;
    padding: 4px 6px;
    width: 0;
    min-width: 30px;
    flex-grow: 1;
    border: 0;
    margin: 0;
    outline: 0;
  }
`;

const Tag = styled(({ label, onDelete, ...props }) => (
  <div {...props}>
    <span>{label}</span>
    <CloseIcon onClick={onDelete} />
  </div>
))`
  display: flex;
  align-items: center;
  height: 24px;
  margin: 2px;
  line-height: 22px;
  background-color: #fafafa;
  border: 1px solid #e8e8e8;
  border-radius: 2px;
  box-sizing: content-box;
  padding: 0 4px 0 10px;
  outline: 0;
  overflow: hidden;

  &:focus {
    border-color: #40a9ff;
    background-color: #e6f7ff;
  }

  & span {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  & svg {
    font-size: 12px;
    cursor: pointer;
    padding: 4px;
  }
`;

const Listbox = styled("ul")`
  width: 300px;
  margin: 2px 0 0;
  padding: 0;
  position: absolute;
  list-style: none;
  background-color: #fff;
  overflow: auto;
  max-height: 250px;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  z-index: 1;

  & li {
    padding: 5px 12px;
    display: flex;

    & span {
      flex-grow: 1;
    }

    & svg {
      color: transparent;
    }
  }

  & li[aria-selected="true"] {
    background-color: #fafafa;
    font-weight: 600;

    & svg {
      color: #1890ff;
    }
  }

  & li[data-focus="true"] {
    background-color: #e6f7ff;
    cursor: pointer;

    & svg {
      color: #000;
    }
  }
`;

class AddAgents extends Component {
  constructor(props) {
    super(props);
    this.state = {
      datasource: ["venu", "gopal"],
      fixedOptions: [top100Films[0]],
      workorderObjects: [],
      agentRole: "",
      selectedClient: "",
      selectedProjects: [],
      selectedApps: [],
      clientsList: [],
      projectsList: [],
      appsList: [],
      firstName: "",
      lastName: "",
      password: "",
      mobile: "",
      reEnterPassword: "",
      startDate: new Date("2020-02-01"),
      endDate: new Date(),
      options: [{ label: "venu" }, { label: "gopal" }],
      wards: [],
      selectedWards: [],
      clients: [],
      selectedClients: [],
      users: [],
      selectedUsers: [],
      wardResult: null,
      loading: false,
      ward: "",
      resultObj: null,
      tableHeader: null,
      tableObj: null,
      propertyResult: null
    };
    this.handleDataChange = this.handleDataChange.bind(this);
    this.callGetClientssApi = this.callGetClientssApi.bind(this);
    this.callGetProjectsApi = this.callGetProjectsApi.bind(this);
    this.getAppsList = this.getAppsList.bind(this);
    self = this;
  }

  componentDidMount() {
    axios
      .get(apiData.getAllWorkorders.url, {
        params: {},
        headers: apiData.headers
      })
      .then(res => {
        if (res.data.status) {
          console.log(res.data.response.WorkOrderObjs, "resss");
          let response = res.data.response.WorkOrderObjs;
          response.map((ele, index) => {
            if (ele.workOrder == "AP1") {
              response.splice(index, 1);
            }
          });
          this.setState({
            workorderObjects: response
          });
        } else {
        }
      });
    axios.get(apiData.ward_report_clients.url, {
          params: {
            work_order: apiData.ward_report_clients.params.work_order
          },
          headers: apiData.headers
        })
        .then(res => {
          if(res.data.ok){
            // let clients = res.data.response.clientObjs.map(item => item.app_name)
            this.setState({clients: res.data.response.clientObjs})
          }
        })
    axios.get(apiData.ward_list.url, {
          params: {
            work_order: "OD1",
            projectId: "ODBN"
          },
          headers: apiData.headers
        })
        .then(res => {
          if(res.data.ok){
            let sortedWardList = res.data.response.wardsList.sort((a,b) => Number(a.wardNo) - Number(b.wardNo))
            this.setState({wards: sortedWardList})
          }
        })
    this.getAppsList();
    this.callGetClientssApi(workOrder);
  }

  componentDidUpdate() {
    let clients = this.state.selectedClients.map(item => item._id);
    axios.get(apiData.ward_report_users.url, {
      params: {
        work_order: apiData.ward_report_users.params.work_order,
        clients
      },
      headers: apiData.headers
    })
    .then(res => {
      if(res.data.response){
        let usersArray = Object.values(res.data.response.results);
        let mergedUsersArray = [].concat.apply([], usersArray);
        let modifiedMergedUsersArray = mergedUsersArray.map(item => {
          return {
            ...item,
            display: `${item.username} (${item.first_name} ${item.last_name})`
          }
        });
        if(mergedUsersArray.length !== this.state.users.length){
          this.setState({users: modifiedMergedUsersArray})
        };
      }
    })
  }

  handleDataChange(data) {
    console.log(data, "datadata");
    // data = { naame: 'name', label: 'label' }
  }
  getAppsList() {
    axios
      .get(apiData.getAppsList.url, {
        params: {},
        headers: apiData.headers
      })
      .then(res => {
        console.log(res, "res appslist");
        if (res.data.status) {
          let response = res.data.response.appList;
          let responseArray = [];
          response.map(ele => {
            let obj = {};
            obj.title = ele;
            responseArray.push(obj);
          });
          this.setState({
            appsList: responseArray
          });
        }
      });
  }

  chipValues(event, newValue) {
    this.setState({
      value: [
        ...this.state.fixedOptions,
        ...newValue.filter(
          option => this.state.fixedOptions.indexOf(option) === -1
        )
      ]
    });
  }

  selectWorkorder(e) {
    document.querySelectorAll(".MuiChip-root").forEach(function(a) {
      a.remove();
    });
    this.setState({
      selectedWorkorder: e.target.value,
      clientsList: [],
      projectsList: [{ title: "" }],
      selectedClient: "",
      selectedProjects: [],
      selectedApps: []
      // value: "",
      // projects: [{ title: "" }]
    });
    if (e.target.value) {
      this.callGetClientssApi(e.target.value);
    }
  }

  callGetClientssApi(workOrder) {
    if (workOrder.workOrder) {
      workOrder = workOrder.workOrder;
    } else {
      workOrder = workOrder;
    }
    if (workOrder) {
      this.setState({
        selectedWorkorder: workOrder
      });
      console.log(workOrder, "workOrder sele--");
      axios
        .get(apiData.getWorkorderClients.url, {
          params: { work_order: workOrder },
          headers: apiData.headers
        })
        .then(res => {
          if (res.data.status) {
            let response = res.data.response.Clients;
            console.log(response, "responseresponse");
            this.setState({
              clientsList: response
            });
          } else {
            toast.error(
              res.data.response.reason
                ? res.data.response.reason
                : "No Clients!",
              {
                position: toast.POSITION.TOP_RIGHT
              }
            );
          }
        });
    }
  }

  callGetProjectsApi(client) {
    if (client) {
      console.log(client, "clientclient");
      let params = {};
      params.work_order = this.state.selectedWorkorder;
      params.client_id = client;
      axios
        .get(apiData.getClientProjects.url, {
          params: params,
          headers: apiData.headers
        })
        .then(res => {
          if (res.data.status) {
            console.log(res.data.response.ulbList, "ress clientProjjj");
            let response = res.data.response.ulbList;
            let responseArray = [];
            response.map(ele => {
              let obj = {};
              obj.title = ele;
              responseArray.push(obj);
            });
            this.setState({
              projectsList: responseArray
            });
          } else {
            toast.error(
              res.data.response.reason
                ? res.data.response.reason
                : "No Projects!",
              {
                position: toast.POSITION.TOP_RIGHT
              }
            );
          }
        });
    } else {
      toast.error("No Client Id!", {
        position: toast.POSITION.TOP_RIGHT
      });
    }
  }

  submitAgent(e) {
    e.preventDefault();
    if(!this.state.selectedWards.length){
      toast.error("Please Select Ward", {
        position: toast.POSITION.TOP_RIGHT
      });
      return
    }
    let selectedWardNumbers = Object.values(this.state.selectedWards.map(item => item.wardNo));
    // let selectedClientsIds = Object.values(this.state.selectedClients.map(item => item._id));
    // let selectedUserIds = Object.values(this.state.selectedUsers.map(item => item._id));
    this.setState({loading: true})
    // axios.get(apiData.ward_analytics.url, {
    //   params: {
    //     work_order: apiData.ward_analytics.params.work_order,
    //     clients: selectedClientsIds,
    //     users: selectedUserIds,
    //     wards: selectedWardNumbers,
    //     fromDate: this.state.startDate,
    //     toDate: this.state.endDate
    //     // work_order: "OD1",
    //     // clients: ["6013c6f27134c77096b0996f"],
    //     // users: ["6018d1ad4f023453f07eecf4"],
    //     // wards: ["23","24"],
    //     // fromDate: "2019-12-30T10:57:09.000Z",
    //     // toDate: "2021-04-26T10:57:09.435Z"
    //   },
    //   headers: apiData.headers
    //   // headers: {
    //   //   'x-zippr-api-key': '1e1352a39ebd3db612cc233e8519bee7f36ca655c43e6cf1783e58c1b31a2d7c', 
    //   //   'x-zippr-sessiontoken': '89128dab065e794232b10c7c501a546b691d0ec8d6806d7ecddb800fd69a5f50',
    //   // }
    // })
    // .then(res => {
    //   this.setState({loading: false})
    //   if(res.data.ok){
    //     // let clients = res.data.response.clientObjs.map(item => item.app_name)
    //     let mappedResult = res.data.response.results.map(item => {
    //       return {
    //         count: item.count,
    //         wardNo: item._id.wardNo,
    //         download: <GetAppIcon onClick={() => this.downloadWardReport(item._id.wardNo)} style={{color: "#e8796a"}}/>
    //       }
    //     })
    //     this.setState({wardResult: mappedResult});
    //   }
    // })
    axios.get(apiData.property_anaylytics.url,{
      params: {
        work_order: "OD1",
        project_id: "ODBN",
        ward_no: selectedWardNumbers,
        fromDate: this.state.startDate,
        toDate: this.state.endDate
        // work_order: "OD1",
        // clients: ["6013c6f27134c77096b0996f"],
        // users: ["6018d1ad4f023453f07eecf4"],
        // wards: ["23","24"],
        // fromDate: "2019-12-30T10:57:09.000Z",
        // toDate: "2021-04-26T10:57:09.435Z"
      },
      headers: apiData.headers
    })
    .then(res => {
      if(res.data.ok){
        // this.setState({resultObj: res.data.response.finalDataObj})
        // let tableObj = {...res.data.response.finalDataObj, DownloadDDN: <GetAppIcon onClick={() => this.downloadReport()} style={{color: "#e8796a"}}/>}
        // this.setState({tableObj: tableObj})
        // this.setState({tableHeader: Object.keys(tableObj)})
        // this.setState({loading: false})
        let mappedResult = res.data.response.finalDataObj.map(item => {
          TableHeader.map(inneritem => {
            if(!item.hasOwnProperty(inneritem)){
              item[inneritem] = 0;
            }
          })
          return {
            ...item,
            Download: <GetAppIcon onClick={() => this.downloadReport(item)} style={{color: "#e8796a"}}/>,
            DownloadRow: <GetAppIcon onClick={() => this.downloadRow(item)} style={{color: "#e8796a"}}/>
          }
        })
        this.setState({propertyResult: mappedResult});
        this.setState({loading: false})
      }
    })
    // work_order=OD1&project_id=ODBN&ward_no=14&fromDate=2020-01-01&toDate=2021-07-01
    // document.querySelectorAll(".sc-dlnjPT").forEach(function(a) {
    // // document.querySelectorAll(".fUJvAw").forEach(function(a) {
    //   // a.style.visibility = "hidden";
    //   a.style.display = "none";
    //   // a.remove();
    // });

    // this.setState({
    //   selectedProjects: selectedProjectsNew
    // });
    // let selectedProjects = selectedProjectsNew;
    // // let selectedProjects = this.state.selectedProjects;
    // let selectedProjectsArray = [];
    // selectedProjects.map(ele => {
    //   if (ele.title) {
    //     selectedProjectsArray.push(ele.title);
    //   }
    // });

    // this.setState({
    //   selectedApps: selectedAppsNew
    // });
    // let selecteApps = [...selectedAppsNew];
    // // let selecteApps = this.state.selectedApps;
    // let selecteAppsArray = [];
    // selecteApps.map(ele => {
    //   if (ele.title) {
    //     selecteAppsArray.push(ele.title);
    //   }
    // });
    // console.log(selecteAppsArray, "selecteAppsArrayvv");
    // console.log(selecteApps, "selecteAppsvv");

    // function _isPhone(phone) {
    //   var regex = /^(\+\d{1,3}[- ]?)?\d{10}$/;
    //   return regex.test(phone);
    // }

    // if (!this.state.selectedWorkorder) {
    //   toast.error("Please Select Workorder", {
    //     position: toast.POSITION.TOP_RIGHT
    //   });
    // }
    // //  else if (!this.state.selectedClient) {
    // //   toast.error("Please Select Client", {
    // //     position: toast.POSITION.TOP_RIGHT
    // //   });
    // // } else if (!selectedProjectsArray.length) {
    // //   toast.error("Please Select Projects", {
    // //     position: toast.POSITION.TOP_RIGHT
    // //   });
    // // }
    // else if (!selecteAppsArray.length) {
    //   toast.error("Please Select Apps", {
    //     position: toast.POSITION.TOP_RIGHT
    //   });
    // } else if (!this.state.firstName) {
    //   toast.error("Please Enter First Name", {
    //     position: toast.POSITION.TOP_RIGHT
    //   });
    // } else if (!this.state.lastName) {
    //   toast.error("Please Enter Last Name", {
    //     position: toast.POSITION.TOP_RIGHT
    //   });
    // } else if (!this.state.agentRole) {
    //   toast.error("Please Select Agent Role", {
    //     position: toast.POSITION.TOP_RIGHT
    //   });
    // } else if (!this.state.mobile) {
    //   toast.error("Please Enter Mobile Number", {
    //     position: toast.POSITION.TOP_RIGHT
    //   });
    // } else if (!_isPhone(this.state.mobile)) {
    //   toast.error("Please Enter Valid Mobile Number", {
    //     position: toast.POSITION.TOP_RIGHT
    //   });
    // } else if (!this.state.password) {
    //   toast.error("Please Enter Password", {
    //     position: toast.POSITION.TOP_RIGHT
    //   });
    // } else if (this.state.password.length < 6) {
    //   toast.error("Minimum Length of Password is 6 Letters", {
    //     position: toast.POSITION.TOP_RIGHT
    //   });
    // } else if (!this.state.reEnterPassword) {
    //   toast.error("Please Enter Confirm Password", {
    //     position: toast.POSITION.TOP_RIGHT
    //   });
    // } else if (this.state.password !== this.state.reEnterPassword) {
    //   toast.error("Password and Re-enter password Must be the Same!", {
    //     position: toast.POSITION.TOP_RIGHT
    //   });
    // } else {
    //   // let selectedUlbs = selectedProjectsNew;
    //   let selectedUlbs = [];
    //   // this.state.selectedProjects.map(ele => {
    //   selectedProjectsNew.map(ele => {
    //     if (ele.title) {
    //       selectedUlbs.push(ele.title);
    //     }
    //   });

    //   let selectedApps = [];
    //   // this.state.selectedApps.map(ele => {
    //   selectedAppsNew.map(ele => {
    //     if (ele.title) {
    //       selectedApps.push(ele.title);
    //     }
    //   });
    //   console.log(selectedApps, selectedUlbs, "selectedUlbshhyy");

    //   let data = {};
    //   data.work_order = this.state.selectedWorkorder;
    //   // data.client_id = this.state.selectedClient;
    //   data.mobile_number = this.state.mobile;
    //   data.password = this.state.password;
    //   data.first_name = this.state.firstName;
    //   data.last_name = this.state.lastName;
    //   data.user_type = this.state.agentRole;
    //   // data.ulbs = selectedUlbs;
    //   data.apps = selectedApps;
    //   data.created_by_username = loginDetails.user
    //     ? loginDetails.user.username
    //     : "";
    //   console.log(data, "dataadataa");
    //   axios
    //     .post(apiData.agentDetails.url, data, {
    //       headers: apiData.headers
    //     })
    //     .then(res => {
    //       console.log(res, "resss post agent");
    //       if (res.data.ok) {
    //         toast.success("Agent Added Sucessfully", {
    //           position: toast.POSITION.TOP_RIGHT
    //         });
    //         document.getElementById("dataForm").reset();
    //         document.querySelectorAll(".sc-dlnjPT").forEach(function(a) {
    //           a.style.display = "none";
    //           // a.remove();
    //         });
    //         // this.callGetClientssApi(workOrder);
    //         this.setState(
    //           {
    //             // selectedWorkorder: "",
    //             selectedClient: "",
    //             selectedProjects: [],
    //             selectedApps: [],
    //             firstName: "",
    //             lastName: "",
    //             agentRole: "",
    //             mobile: "",
    //             password: "",
    //             reEnterPassword: "",
    //             // clientsList: [],
    //             projectsList: [{ title: "" }],
    //             selectedProjects: [],
    //             selectedApps: [],
    //             appsList: []
    //           },
    //           () => {
    //             this.getAppsList();
    //           }
    //         );
    //         selecteAppsArray = [];
    //         selectedAppsNew = [];
    //         selecteApps = [];
    //         console.log(
    //           selecteApps,
    //           selecteAppsArray,
    //           selectedAppsNew,
    //           "pppooooo"
    //         );
    //       } else {
    //         toast.error(
    //           res.data.error.reason ? res.data.error.reason : "Error!",
    //           {
    //             position: toast.POSITION.TOP_RIGHT
    //           }
    //         );
    //       }
    //     });
    // }
  }

  // downloadTable() {
  //   let columns = {};
  //   for(let i = 0; i < this.state.tableHeader.length; i++){
  //     // if(TableHeader[i] !== "Download"){
  //       columns[this.state.tableHeader[i]] = this.state.tableHeader[i]
  //     // }
  //   }
  //   downloadCsv(this.state.tableObj, columns, 'fullPropertyReport.csv')
  // }

  downloadReport(item) {
    axios.get(apiData.download_metadata.url, {
      params: {
        work_order: "OD1",
        project_id: "ODBN",
        ward: item.ward,
        fromDate: this.state.startDate,
        toDate: this.state.endDate,
      },
      headers: apiData.headers
    })
    .then(res => {
      if(res.data.ok){
        let columns = {}
        for(let i = 0; i < res.data.response.headers.length; i++){
          columns[res.data.response.headers[i]] = res.data.response.headers[i];
        }
        downloadCsv(res.data.response.ddns, columns, `propertyreport-${item.ward}.csv`);
      }
    })
  }

  downloadRow(item) {
    const DownloadRowHeader = ["ward","Bus_Stand","Commercial","Community_Hall","Educational","GOI_Office","Industrial","Institutional","Mixed","Others","Railway_Station","Religious-Hindu_Temple","Religious-Majid","Religious-Church","Religious-Other","Residential","Slum","State_Govt_Office","Storage_Building","Under_Construction","Unsafe"];
    let downloadArr = [];
    delete item.Download;
    delete item.DownloadRow;
    downloadArr.push(item)
    downloadCsv(downloadArr, DownloadRowHeader, `Property-${item.ward}.csv`)
  }

  downloadTable() {
    const DownloadTableHeader = ["ward","Bus_Stand","Commercial","Community_Hall","Educational","GOI_Office","Industrial","Institutional","Mixed","Others","Railway_Station","Religious-Hindu_Temple","Religious-Majid","Religious-Church","Religious-Other","Residential","Slum","State_Govt_Office","Storage_Building","Under_Construction","Unsafe"];
    let downloadArr = [];
    for(let i = 0; i < this.state.propertyResult.length; i++){
      delete this.state.propertyResult[i].Download;
      downloadArr.push(this.state.propertyResult[i])
    }
    downloadCsv(downloadArr, DownloadTableHeader, 'PropertyTable.csv')
  }

  projectsChange(e) {
    console.log(e.target.value, "selprooj");
  }

  render() {
    console.log(selectedProjectsNew, "rendr state");
    return (
      <div className="container hole-container" style={{ width: "76em" }}>
        <h6 className="page-header">Ward Report</h6>
        <form className="form-style" id="dataForm">

          <div className="row data-row">
            <div className="col-md-2 label-class">
              <span className="label-text">Start Date</span>
            </div>
            <div className="col-md-4 select-bordered-div">
              <Grid item md={12} xs={12}>
                <DatePicker className="date-button" selected={this.state.startDate} onChange={date => this.setState({startDate: date})} />
              </Grid>
            </div>
            <div className="col-md-2 label-class">
              <span className="label-text">End Date</span>
            </div>
            <div className="col-md-4 select-bordered-div">
              <Grid item md={12} xs={12}>
                <DatePicker className="date-button" selected={this.state.endDate} onChange={date => this.setState({endDate: date})} />
              </Grid>
            </div>
          </div>

          {/* <div className="row data-row">
            <div className="col-md-2 label-class">
              <span className="label-text">End Date</span>
            </div>
            <div className="col-md-2 select-bordered-div">
              <Grid item md={12} xs={12}>
                <DatePicker className="date-button" selected={this.state.endDate} onChange={date => this.setState({endDate: date})} />
              </Grid>
            </div>
          </div> */}

          <div className="row data-row">
            <div className="col-md-2 label-class">
              <span className="label-text">Ward</span>
            </div>
            <div className="col-md-8 select-bordered-div">
              <Grid item md={12} xs={12}>
                {/* <TextField
                  fullWidth
                  // label="Select State"
                  name="state"
                  label="Ward"
                  onChange={e => {
                    this.setState({ ward: e.target.value });
                  }}
                  // select
                  // eslint-disable-next-line react/jsx-sort-props
                  // SelectProps={{ native: true }}
                  value={this.state.ward}
                  variant="outlined"
                ></TextField> */}
                <Multiselect 
                  style={{
                    chips: { // To change css chips(Selected options)
                      background: "#e8796a"
                    },
                  }}
                  options={this.state.wards} 
                  onSelect={(items) => this.setState({selectedWards: items})} 
                  onRemove={(items) => this.setState({selectedWards: items})} 
                  displayValue="wardNo" 
                  showCheckbox={true}
                  selectedValues={this.state.selectedWards}/>
              </Grid>
            </div>
            <div className="col-md-1 select-bordered-div" style={{fontSize: '12px', color: "#e8796a", textDecoration: 'underline'}} onClick={() => this.setState({selectedWards: this.state.wards})}>
              Select All
            </div>
            <div className="col-md-1 select-bordered-div" style={{fontSize: '12px', color: "#e8796a", textDecoration: 'underline'}} onClick={() => this.setState({selectedWards: []})}>
              Clear All
            </div>
          </div>

          <br />
          <div className="row">
            <div className="col-md-10"></div>
            <div className="col-md-2">
              <Button
                variant="contained"
                color="primary"
                component="span"
                onClick={this.submitAgent.bind(this)}
                style={{background: "#e8796a"}}
              >
                Submit
              </Button>
            </div>
          </div>
        </form>
        {this.state.loading && <img src={loader}/>}
        {this.state.propertyResult && <h5 style={{color: "#e8796a", textAlign: 'left', textDecoration: 'underline'}} onClick={() => this.downloadTable()}>Download All</h5>}
        {this.state.propertyResult && <div style={{marginTop: '20px', marginBottom: '20px'}}>
	        <TablePagination
              title="Ward Report"
              // subTitle="Sub Title"
              headers={ TableHeader }
              data={ this.state.propertyResult }
              columns="ward.Bus_Stand.Commercial.Community_Hall.Educational.GOI_Office.Industrial.Institutional.Mixed.Others.Railway_Station.Religious-Hindu_Temple.Religious-Majid.Religious-Church.Religious-Other.Residential.Slum.State_Govt_Office.Storage_Building.Under_Construction.Unsafe.grand_total.Download.DownloadRow"
              perPageItemCount={ 20 }
              totalCount={ this.state.propertyResult.length }
              // arrayOption={ [["size", 'all', ' ']] }
	            paginationClassName="pagination"
            />
	      </div>}
      </div>
    );
  }
}

export function CustomizedHook() {
  const {
    getRootProps,
    getInputLabelProps,
    getInputProps,
    getTagProps,
    getListboxProps,
    getOptionProps,
    groupedOptions,
    value,
    focused,
    setAnchorEl
  } = useAutocomplete({
    id: "customized-hook-demo",
    // defaultValue: [top100Films[1]],
    multiple: true,
    options: self.state.projectsList,
    getOptionLabel: option => option.title
  });
  console.log(value, "valueoo");
  console.log(focused, "focusedoo");
  selectedProjectsNew = [...value];
  // self.setState({
  //   selectedProjects: value
  // });

  return (
    <NoSsr>
      <div>
        <div {...getRootProps()}>
          {/* <Label {...getInputLabelProps()}>Customized hook</Label> */}
          <InputWrapper
            ref={setAnchorEl}
            className={focused ? "focused" : ""}
            style={{ width: "100%", height: "3em" }}
          >
            {selectedProjectsNew.map((option, index) => (
              <Tag label={option.title} {...getTagProps({ index })} />
            ))}

            <input {...getInputProps()} />
          </InputWrapper>
        </div>
        {groupedOptions.length > 0 ? (
          <Listbox {...getListboxProps()} style={{ "z-index": "2" }}>
            {groupedOptions.map((option, index) => (
              <li {...getOptionProps({ option, index })}>
                <span>{option.title}</span>
                <CheckIcon fontSize="small" />
              </li>
            ))}
          </Listbox>
        ) : null}
      </div>
    </NoSsr>
  );
}

export function AppsHook() {
  const {
    getRootProps,
    getInputLabelProps,
    getInputProps,
    getTagProps,
    getListboxProps,
    getOptionProps,
    groupedOptions,
    value,
    focused,
    setAnchorEl
  } = useAutocomplete({
    id: "customized-hook-demo",
    // defaultValue: [top100Films[1]],
    multiple: true,
    options: self.state.appsList,
    getOptionLabel: option => option.title
  });
  console.log(value, "valueoo apps");
  console.log(focused, "focusedoo");
  selectedAppsNew = [...value];

  return (
    <NoSsr>
      <div>
        <div {...getRootProps()}>
          {/* <Label {...getInputLabelProps()}>Customized hook</Label> */}
          <InputWrapper
            ref={setAnchorEl}
            className={focused ? "focused" : ""}
            style={{ width: "100%", height: "3em" }}
          >
            {value.map((option, index) => (
              <Tag label={option.title} {...getTagProps({ index })} />
            ))}

            <input {...getInputProps()} />
          </InputWrapper>
        </div>
        {groupedOptions.length > 0 ? (
          <Listbox {...getListboxProps()} style={{ "z-index": "2" }}>
            {groupedOptions.map((option, index) => (
              <li {...getOptionProps({ option, index })}>
                <span>{option.title}</span>
                <CheckIcon fontSize="small" />
              </li>
            ))}
          </Listbox>
        ) : null}
      </div>
    </NoSsr>
  );
}

export default AddAgents;
